import {
  Button,
  Link,
  Toast,
  ToastFooter,
  ToastTitle,
  ToastTrigger,
  makeStyles,
  tokens,
} from '@fluentui/react-components'
import { Dismiss12Regular } from '@fluentui/react-icons'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'
import type { NotifyLink } from '../../contexts/NotificationContext'

type NotificationToastProps = {
  text: string
  link?: NotifyLink
}

const useStyles = makeStyles({
  toast: {
    backgroundColor: tokens.colorNeutralBackgroundInverted,
    color: tokens.colorNeutralForegroundInverted,
  },
  title: {
    color: 'inherit',
  },
  actionButton: {
    color: 'inherit',
  },
})

const NotificationToast = ({ text, link }: NotificationToastProps) => {
  const { t } = useTranslation()
  const classes = useStyles()
  const navigate = useNavigate()

  return (
    <Toast className={classes.toast}>
      <ToastTitle
        action={
          <ToastTrigger>
            <Button
              appearance="subtle"
              size="small"
              icon={<Dismiss12Regular />}
              aria-label={t('close')}
              className={classes.actionButton}
            />
          </ToastTrigger>
        }
        className={classes.title}>
        {text}
      </ToastTitle>
      {link ? (
        <ToastFooter>
          {/* temporary disabled until navigation is implemented in #4064 */}
          <Link
            as="a"
            href={link.href}
            disabled
            onClick={(e) => {
              // use React Router implementation for navigation while using Fluent UI component for styling
              e.preventDefault()
              navigate(link.href)
            }}>
            {link.label}
          </Link>
        </ToastFooter>
      ) : null}
    </Toast>
  )
}

export { NotificationToast }
